module.exports = __webpack_public_path__ + "img/fitshow-title-back-image-1.5a475f2e.jpg";